import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user'])
  },
  methods: {
    img: str => `${process.env.VUE_APP_STORAGE_URL}/${str}`,
    chunk(array, size) {
      const chunkedArr = []
      for (let i = 0; i < array.length; i += 1) {
        const last = chunkedArr[chunkedArr.length - 1]
        if (!last || last.length === size) {
          chunkedArr.push([array[i]])
        } else {
          last.push(array[i])
        }
      }
      return chunkedArr
    },
    loadCountries() {
      this.$http
        .get('country-phone-codes')
        .then((res) => {
          const countryCodes = res.data.data
          this.phoneCountryCodes = countryCodes
          this.setCountryCodesObj(countryCodes)
        })
        .catch(() => {
          // this.alert(this.$t('error')+'!', this.$t('data_loading_error'), 'error')
        })
    },
    setCountryCodesObj(codes) {
      Object.entries(codes).forEach(([key, value]) => {
        this.phoneCountryCodesObj.push({
          id: value,
          name: value,
          country: key,
          label: `${key} +${value}`
        })
      })
    },
    userPermissions() {
      if (!this.user.data.permissions) {
        window.localStorage.removeItem('user')
        window.location.reload()
        return []
      }
      return this.user.data.permissions
    },
    userPermissionCheck(permission) {
      return this.userPermissions().includes(permission)
    },
    isDashboardPermission() {
      return this.userPermissionCheck('view-dashboard')
    }
  }
}
